'use strict';

angular.module('docketbook')
  .controller('docketDesignerController', function (docketService, uuid, resourceService, Upload, $q, $scope, $window, Restangular, $state, $stateParams, $timeout, accessControl, ObjectDiff) {
    mixpanel.track("Opened DocketDesigner Desktop");

    $scope.currentUser = $state.params.currentUser;
    $scope.currentState = $state.current;
    $scope.currentOrg = accessControl.currentOrg();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    if ($stateParams.mode == 'configure') {
      $scope.mode = 'configure';
    } else {
      $scope.mode = 'preview';
    }
    $scope.rightPane = { view: 'fields' };

    $scope.templateEdit = {};
    $scope.originalTemplate = {};
    $scope.currentSection = null;
    $scope.activityEdit = null;
    $scope.allFields = [];
    $scope.availablePrefillFields = [];
    $scope.allChecklists = [];
    $scope.allResourceCategories = [];

    $scope.availablePdfBuilders = [{
      name: 'standard',
      displayName: 'Standard'
    }, {
      name: 'standardOpt',
      displayName: 'Modern'
    }, {
      name: 'compact',
      displayName: 'Compact'
    }];

    /*********************/
    /* Main Data Methods */
    /*********************/

    /* Get Field Data */
    $scope.getFields = function () {
      docketService.getFields({}, function (fields) {
        $scope.allFields = fields;
      }, function (err) {
        $scope.allFields = [];
      });
    }
    $scope.getFields();

    /* Get Checklist Templates */
    $scope.getChecklists = function () {
      docketService.getChecklistTemplates({}, function (checklistTemplates) {
        $scope.allChecklists = checklistTemplates;
      }, function (err) {
        $scope.allChecklists = [];
      });
    }

    $scope.getChecklists();

    /* Get Resource Categories */
    $scope.getResourceCategories = function () {
      resourceService.getResourceCategories({}, function (categories) {
        $scope.allResourceCategories = categories;
      }, function (err) {
        $scope.allResourceCategories = [];
      });
    }

    $scope.getResourceCategories();

    /* Get Tempalate Detail */
    $scope.getTemplate = function () {
      if ($stateParams.templateId && $stateParams.templateId != 'new') {
        docketService.getTemplate($stateParams.templateId, function (templateFull) {
          $scope.templateEdit = templateFull;
          var existingStandardBlocks = [];
          for (var i = 0; i < $scope.templateEdit.blocks.length; i++) {
            if ($scope.templateEdit.blocks[i].type != 'custom') {
              existingStandardBlocks.push($scope.templateEdit.blocks[i].type);
            }
          }
          $scope.templateEdit.existingStandardBlocks = existingStandardBlocks;

          // setup interaction templates for categories matrix editing
          var interactionTemplatesMatrix = {};
          for (var i = 0; i < $scope.templateEdit.interactionTemplates.length; i++) {
            var templateMatrix = {};
            for (var j = 0; j < $scope.templateEdit.interactionTemplates[i].actorCategories.length; j++) {
              templateMatrix[$scope.templateEdit.interactionTemplates[i].actorCategories[j].id] = true;
            }
            interactionTemplatesMatrix[$scope.templateEdit.interactionTemplates[i].name] = templateMatrix;
          }
          $scope.templateEdit.interactionTemplatesMatrix = interactionTemplatesMatrix;
          if ($scope.templateEdit.checklistContainers == null) {
            $scope.templateEdit.checklistContainers = [];
          }
          $scope.templateEdit.blockVisibilitySettings = {};
          for (var i = 0; i < $scope.templateEdit.blocks.length; i++) {
            var blockName = $scope.templateEdit.blocks[i].name;
            if ($scope.templateEdit.blocks[i].type != 'custom') {
              blockName = $scope.templateEdit.blocks[i].type;
            }
            if ($scope.templateEdit.hiddenBlockNames.indexOf(blockName) != -1) {
              $scope.templateEdit.blockVisibilitySettings[blockName] = false;
            } else {
              $scope.templateEdit.blockVisibilitySettings[blockName] = true;
            }
          }
          // setup prefill fields list
          $scope.templateEdit.addPrefillField = {};
          $scope.templateEdit.updateOrderPrefillFields = {};
          if (!$scope.templateEdit.orderPrefillFields) {
            $scope.templateEdit.orderPrefillFields = [];
          } else {
            for (var i = 0; i < $scope.templateEdit.orderPrefillFields.length; i++) {
              // populate with full field
              for (var j = 0; j < $scope.allFields.length; j++) {
                if ($scope.allFields[j].id == $scope.templateEdit.orderPrefillFields[i]) {
                  $scope.templateEdit.orderPrefillFields[i] = $scope.allFields[j];
                  $scope.templateEdit.updateOrderPrefillFields[$scope.allFields[j].id] = true;
                  break;
                }
              }
            }
          }
          $scope.updateAvailablePrefillFields($scope.templateEdit);

          $scope.templateEdit = Restangular.stripRestangular($scope.templateEdit);
          $scope.originalTemplate = angular.copy($scope.templateEdit);
        }, function (err) {
          $scope.templateEdit = {};
        });
      } else if ($stateParams && $stateParams.templateId == 'new') {
        $scope.mode = 'new';
        $scope.newTemplateStep = 1;
        $scope.newTemplateWizard = { sectionsIncluded: [] };
        $("#templateWizardStep1").fadeIn(200);
        $scope.templateEdit = {};
        $scope.templateEdit.editing = true;
        $scope.templateEdit.checklistContainers = [];
        $scope.templateEdit.signature = true;
        $scope.templateEdit.blocks = [];
        $scope.templateEdit.blockVisibilitySettings = {};
        $scope.templateEdit.interactionTemplates = [];
        $scope.templateEdit.interactionTemplatesMatrix = {};
        $scope.originalTemplate = angular.copy($scope.templateEdit);
      }
    }

    $scope.getTemplate();

    /********************/
    /* UI Functionality */
    /********************/

    $scope.updateAvailablePrefillFields = function (template) {
      var availableFields = [];
      // get list of all fields on docket template
      var allTemplateFields = {};
      for (var i = 0; i < template.blocks.length; i++) {
        if (template.blocks[i].fields) {
          for (var j = 0; j < template.blocks[i].fields.length; j++) {
            if (!allTemplateFields[template.blocks[i].fields[j].id]) {
              allTemplateFields[template.blocks[i].fields[j].id] = template.blocks[i].fields[j];
            }
          }
        }
      }
      var templateFieldIds = Object.keys(allTemplateFields);

      for (var i = 0; i < templateFieldIds.length; i++) {
        // check if this field is in template.orderPrefillFields
        var isUsed = false;
        for (var j = 0; j < template.orderPrefillFields.length; j++) {
          if (template.orderPrefillFields[j].id == templateFieldIds[i]) {
            isUsed = true;
          }
        }
        if (!isUsed) {
          availableFields.push(allTemplateFields[templateFieldIds[i]]);
        }
      }
      $scope.availablePrefillFields = availableFields;
    }

    $scope.addPrefillField = function () {
      if ($scope.templateEdit.addPrefillField && $scope.templateEdit.addPrefillField.id) {
        $scope.templateEdit.orderPrefillFields.push($scope.templateEdit.addPrefillField);
        $scope.templateEdit.updateOrderPrefillFields[$scope.templateEdit.addPrefillField.id] = true;
        $scope.templateEdit.addPrefillField = {};
        $scope.updateAvailablePrefillFields($scope.templateEdit);
      }
    }

    $scope.backToTemplates = function () {
      $scope.templateEdited = angular.copy($scope.templateEdit);
      $scope.templateEdited = JSON.parse(angular.toJson($scope.templateEdited));
      var diffCount = 0;
      if ($scope.templateEdit.id == null) {
        diffCount = 1;
      } else {
        var diff = ObjectDiff.diff($scope.templateEdited, $scope.originalTemplate);
        var standardFields = ['active', 'attachments', 'blocks', 'checklistContainers', 'interactionTemplates', 'name', 'populateResourcesFromJob', 'published', 'signature'];
        if (diff.changed != 'equal') {
          standardFields.forEach(function (field) {
            if (diff.value[field].changed != 'equal') {
              diffCount += 1;
            }
          });
        }
      }

      if (diffCount <= 0) {
        $state.go('companySettings.templates', { orgId: $scope.currentOrg.id });
      } else {
        var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
        $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
          if (actionSelected == 'save') {
            $scope.saveTemplateEdit();
          } else if (actionSelected == 'dontSave') {
            $state.go('companySettings.templates', { orgId: $scope.currentOrg.id });
          } else {
            // do nothing - stay where we are
          }
        });
      }
    }

    $scope.newTemplateWizardNext = function () {
      $("#templateWizardStep" + $scope.newTemplateStep).fadeOut(200, function () {
        $scope.newTemplateStep += 1;
        $("#templateWizardStep" + $scope.newTemplateStep).fadeIn(200);
      });
    }

    $scope.newTemplateWizardBack = function () {
      $("#templateWizardStep" + $scope.newTemplateStep).fadeOut(200, function () {
        $scope.newTemplateStep -= 1;
        $("#templateWizardStep" + $scope.newTemplateStep).fadeIn(200);
      });
    }

    $scope.newTemplateWizardSubmit = function () {
      $scope.templateEdit.loading = true;
      $("#templateWizardStep" + $scope.newTemplateStep).fadeOut(200, function () {
        $("#templateWizardCreating").fadeIn(200);
      });
      $scope.templateEdit.blocks = [];
      for (var i = 0; i < $scope.newTemplateWizard.sectionsIncluded.length; i++) {
        $scope.templateEdit.blocks.push({ type: $scope.newTemplateWizard.sectionsIncluded[i] });
      }
      $timeout(function () {
        $scope.saveTemplateEdit(true);
      }, 2000);
    }

    $scope.newTemplateWizardTC = function (addTc) {
      if (addTc) {
        $scope.newTemplateWizardNext();
      } else {
        $scope.newTemplateWizardSubmit();
      }
    }

    $scope.selectNewTemplateSection = function (sectionName) {
      var index = $scope.newTemplateWizard.sectionsIncluded.indexOf(sectionName);
      if (index == -1) {
        $scope.newTemplateWizard.sectionsIncluded.push(sectionName);
        $(".newTemplateWizardSections .sectionType." + sectionName).addClass('selected');
      } else {
        $scope.newTemplateWizard.sectionsIncluded.splice(index, 1);
        $(".newTemplateWizardSections .sectionType." + sectionName).removeClass('selected');
      }
    }

    $scope.openBuildMode = function () {
      $scope.mode = 'build';
      $scope.openLeftPane();
      if ($scope.currentSection && ($scope.currentSection.type == 'custom' || $scope.activityEdit != null)) {
        $scope.openRightPane('fields');
      }
    }

    $scope.openPreviewMode = function () {
      $scope.mode = 'preview';
      $scope.closeLeftPane();
      $scope.closeRightPane();
    }

    $scope.openConfigureMode = function () {
      $scope.mode = 'configure';
      $scope.closeLeftPane();
      $scope.closeRightPane();
    }

    $scope.openLeftPane = function () {
      $("#leftControlPane").css({ 'display': 'block' });
      if ($scope.windowWidth < 1600) {
        $scope.minimiseLeftPane();
      } else {
        $("#leftControlPane").animate({
          'left': '0px'
        }, 200, function () {
          $scope.checkLeftPaneHoverOut();
        });
      }
    }

    $scope.closeLeftPane = function () {
      $("#leftControlPane").animate({
        'left': '-250px'
      }, 200, function () {
        $("#leftControlPane").css({ 'display': 'none' });
      });
    }

    $scope.openRightPane = function (view) {
      $scope.rightPane.view = view;
      $("#rightControlPane").css({ 'display': 'block' });
      if ($scope.windowWidth < 1600) {
        $scope.minimiseRightPane();
      } else {
        $("#rightControlPane").animate({
          'right': '0px'
        }, 200);
        $scope.checkRightPaneHover();
      }
    }

    $scope.closeRightPane = function () {
      $("#rightControlPane").animate({
        'right': '-250px'
      }, 200, function () {
        $("#rightControlPane").css({ 'display': 'none' });
      });
    }

    $scope.fetchAvailableFieldsForCurrentBlock = function () {
      $scope.availableFields = [];
      var block = $scope.currentSection;
      for (var i = 0; i < $scope.allFields.length; i++) {
        var found = false;
        for (var j = 0; j < block.fields.length; j++) {
          if (block.fields[j].id == $scope.allFields[i].id) {
            found = true;
            break;
          }
        }
        if (!found) {
          $scope.availableFields.push($scope.allFields[i]);
        }
      }
    }

    $scope.fetchAvailableChecklistContainersForCurrentBlock = function () {
      $scope.availableChecklists = [];
      for (var i = 0; i < $scope.allChecklists.length; i++) {
        var found = false;
        for (var j = 0; j < $scope.templateEdit.checklistContainers.length; j++) {
          if ($scope.templateEdit.checklistContainers[j].checklistTemplate.id == $scope.allChecklists[i].id) {
            found = true;
            break;
          }
        }
        if (!found) {
          var location = 1;
          if ($scope.templateEdit.checklistContainers.length > 0 && $scope.templateEdit.checklistContainers[$scope.templateEdit.checklistContainers.length - 1].location != null) {
            location = $scope.templateEdit.checklistContainers[$scope.templateEdit.checklistContainers.length - 1].location + 1
          }
          var newChecklistContainer = { location: location, rule: 'notRequired', checklistTemplate: $scope.allChecklists[i] };
          $scope.availableChecklists.push(newChecklistContainer);
        }
      }
    }

    $scope.fetchAvailableFieldsForCurrentActivity = function () {
      $scope.availableFields = [];
      for (var i = 0; i < $scope.allFields.length; i++) {
        var found = false;
        for (var j = 0; j < $scope.activityEdit.fields.length; j++) {
          if ($scope.allFields[i].id == $scope.activityEdit.fields[j].id) {
            found = true;
            break;
          }
        }
        if (!found && $scope.allFields[i].type != 'label' && $scope.allFields[i].type != 'multiline' && $scope.allFields[i].type != 'signature') {
          $scope.availableFields.push($scope.allFields[i]);
        }
      }
    }

    $scope.editSection = function (block) {
      $scope.currentSection = block;
      if (block.type == 'time') {
        $scope.currentSectionName = 'Time';
        $scope.closeRightPane();
      } else if (block.type == 'signatures') {
        $scope.currentSectionName = 'Signatures';
        $scope.closeRightPane();
      } else if (block.type == 'resources') {
        $scope.currentSectionName = 'Resources';
        $scope.closeRightPane();
      } else if (block.type == 'checklists') {
        $scope.currentSectionName = 'Checklists';
        $scope.fetchAvailableChecklistContainersForCurrentBlock();
        $scope.openRightPane('checklists');
      } else if (block.type == 'custom') {
        $scope.fetchAvailableFieldsForCurrentBlock();
        $scope.openRightPane('fields');
      }
    }

    $scope.newFieldList = [];

    $scope.fieldDragDropped = function (item, data) {
      var newestField = null;
      if ($scope.activityEdit != null) {
        newestField = $scope.activityEdit.fields[$scope.activityEdit.fields.length - 1];
      } else {
        newestField = $scope.currentSection.fields[$scope.currentSection.fields.length - 1];
      }
      var index = -1;
      for (var i = 0; i < $scope.availableFields.length; i++) {
        if ($scope.availableFields[i].id == newestField.id) {
          index = i;
          break;
        }
      }
      if (index != -1) {
        $scope.availableFields.splice(index, 1);
      }
      $scope.updateAvailablePrefillFields($scope.templateEdit);
    }

    $scope.checklistDragDropped = function (item, data) {
      var newestChecklist = $scope.templateEdit.checklistContainers[$scope.templateEdit.checklistContainers.length - 1];
      var index = -1;
      for (var i = 0; i < $scope.availableChecklists.length; i++) {
        if ($scope.availableChecklists[i].checklistTemplate.id == newestChecklist.checklistTemplate.id) {
          index = i;
          break;
        }
      }
      if (index != -1) {
        $scope.availableChecklists.splice(index, 1);
      }
    }

    $scope.addNewBlock = function () {
      // re-generate list of used blocks
      var existingStandardBlocks = [];
      for (var i = 0; i < $scope.templateEdit.blocks.length; i++) {
        if ($scope.templateEdit.blocks[i].type != 'custom') {
          existingStandardBlocks.push($scope.templateEdit.blocks[i].type);
        }
      }
      $scope.templateEdit.existingStandardBlocks = existingStandardBlocks;
      var newBlock = { type: 'new', name: 'New Section', fields: [] };
      $scope.closeRightPane();
      $scope.currentSection = newBlock;
    }

    $scope.selectNewBlockType = function (type) {
      $scope.currentSection.type = type;
      $scope.templateEdit.blocks.push($scope.currentSection);
      $scope.editSection($scope.templateEdit.blocks[$scope.templateEdit.blocks.length - 1]);
    }

    $scope.deleteCurrentSection = function () {
      $scope.currentSection.loading = true;
      swal({
        title: "Are you sure?",
        text: "Do you really want to delete this section?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          var index = $scope.templateEdit.blocks.indexOf($scope.currentSection);

          if ($scope.currentSection.type == 'checklists') {
            $scope.templateEdit.checklistContainers = [];
          }

          if (index != -1) {
            $scope.templateEdit.blocks.splice(index, 1);
            $scope.currentSection = null;
          }

          $scope.closeRightPane();
        } else {
          $scope.currentSection.loading = false;
        }
      });
    }

    $scope.deleteSection = function (block) {
      block.loading = true;
      swal({
        title: "Are you sure?",
        text: "Do you really want to delete this section?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          if (block.type === 'signatures') {
            $scope.templateEdit.signature = false;
          }

          if ($scope.currentSection.id == block.id) {
            $scope.closeCurrentSection();
          }
          var index = $scope.templateEdit.blocks.indexOf(block);

          if (index != -1) {
            $scope.templateEdit.blocks.splice(index, 1);
          }


        } else {
          block.loading = false;
        }
      });

    }

    $scope.removeFieldFromBlock = function (field, block) {
      var index = block.fields.indexOf(field);
      if (index != -1) {
        block.fields.splice(index, 1);
      }
      $scope.fetchAvailableFieldsForCurrentBlock();
      $scope.updateAvailablePrefillFields($scope.templateEdit);
    }

    $scope.removeChecklistContainer = function (checklistContainer) {
      var index = $scope.templateEdit.checklistContainers.indexOf(checklistContainer);
      if (index != -1) {
        $scope.templateEdit.checklistContainers.splice(index, 1);
      }
      $scope.fetchAvailableChecklistContainersForCurrentBlock();
    }

    $scope.saveCurrentSection = function () {
      if ($scope.currentSection.type == 'custom') {
        $scope.templateEdit.blockVisibilitySettings[$scope.currentSection.name] = true;
      } else {
        $scope.templateEdit.blockVisibilitySettings[$scope.currentSection.type] = true;
      }
      $scope.currentSection = null;
      $scope.closeRightPane();
    }

    $scope.closeCurrentSection = function () {
      $scope.currentSection = null;
      $scope.closeRightPane();
    }

    $scope.newActivity = function () {
      $scope.activityEdit = { 'new': true, name: '', categories: [], actorCategories: [], actorFromOrder: false, billable: true, xeroQuantity: false, fields: [], refersParent: true };
      $scope.fetchAvailableFieldsForCurrentActivity();
      $scope.openRightPane('fields');
    }

    $scope.editActivity = function (activity) {
      $scope.activityEdit = activity;
      $scope.fetchAvailableFieldsForCurrentActivity();
      $scope.openRightPane('fields');
    }

    $scope.closeActivityEdit = function () {
      $scope.activityEdit = null;
      $scope.closeRightPane();
    }

    $scope.deleteActivity = function (interactionTemplate) {
      var index = $scope.templateEdit.interactionTemplates.indexOf(interactionTemplate);
      if (index != -1) {
        $scope.templateEdit.interactionTemplates.splice(index, 1);
      }
    }

    $scope.removeFieldFromActivity = function (field, activity) {
      var index = activity.fields.indexOf(field);
      if (index != -1) {
        activity.fields.splice(index, 1);
      }
      $scope.fetchAvailableFieldsForCurrentActivity();
    }

    $scope.saveActivityEdit = function () {
      if ($scope.activityEdit.new == true) {
        $scope.templateEdit.interactionTemplates.push($scope.activityEdit);
      }
      delete $scope.activityEdit.new;
      if ($scope.templateEdit.interactionTemplatesMatrix[$scope.activityEdit.name] == null) {
        $scope.templateEdit.interactionTemplatesMatrix[$scope.activityEdit.name] = {};
      }
      $scope.closeActivityEdit();
    }

    $scope.saveTemplateEdit = function (reloadSavedTemplate) {
      if ($scope.templateEdit.blocks.filter(block => block.name == '').length > 0) {
        swal({
          title: "Oops!",
          text: "Please make sure all sections have a name before continuing.",
          type: "error",
          confirmButtonText: "Ok, got it."
        });
        return;
      }

      $scope.templateEdit.loading = true;

      // convert interactionTemplatesMatrix back to interactionTemplates categories list
      for (var i = 0; i < $scope.templateEdit.interactionTemplates.length; i++) {
        var thisTemplate = $scope.templateEdit.interactionTemplates[i];
        var actorCategories = [];
        for (var j = 0; j < $scope.allResourceCategories.length; j++) {
          if ($scope.templateEdit.interactionTemplatesMatrix[thisTemplate.name][$scope.allResourceCategories[j].id] == true) {
            actorCategories.push($scope.allResourceCategories[j]);
          }
        }
        thisTemplate.actorCategories = actorCategories;
      }

      delete $scope.templateEdit.interactionTemplatesMatrix;

      // convert hidden blocks from visibility editor format to list of strings
      var newHiddenBlocksList = [];
      for (var i = 0; i < $scope.templateEdit.blocks.length; i++) {
        var blockName = $scope.templateEdit.blocks[i].name;
        if ($scope.templateEdit.blocks[i].type != 'custom') {
          blockName = $scope.templateEdit.blocks[i].type;
        }
        if ($scope.templateEdit.blockVisibilitySettings[blockName] == false) {
          newHiddenBlocksList.push(blockName);
        }
      }

      $scope.templateEdit.hiddenBlockNames = newHiddenBlocksList;

      // convert orderPrefillFields to id list
      if ($scope.templateEdit.orderPrefillFields) {
        for (var i = 0; i < $scope.templateEdit.orderPrefillFields.length; i++) {
          $scope.templateEdit.orderPrefillFields[i] = $scope.templateEdit.orderPrefillFields[i].id;
        }
      }
      // filter out prefill fields that have been unselected
      var filteredPrefillFields = [];
      if ($scope.templateEdit.orderPrefillFields) {
        for (var i = 0; i < $scope.templateEdit.orderPrefillFields.length; i++) {
          if ($scope.templateEdit.updateOrderPrefillFields[$scope.templateEdit.orderPrefillFields[i]] == true) {
            filteredPrefillFields.push($scope.templateEdit.orderPrefillFields[i]);
          }
        }
      }
      $scope.templateEdit.orderPrefillFields = filteredPrefillFields;
      docketService.saveTemplate($scope.templateEdit, function (templateSaved) {
        if (reloadSavedTemplate && reloadSavedTemplate == true) {
          $state.go('docketDesigner', { orgId: $scope.currentOrg.id, templateId: templateSaved.id });
        } else {
          $state.go('companySettings.templates', { orgId: $scope.currentOrg.id });
        }
      }, function (err) {
        $scope.templateEdit.loading = false;
        if ((err.data.statusCode === 400) && (JSON.parse(err.data.message).message === "A template can not be un-published once it is published")) {
          err.status = 999;
        }
        $scope.alertService.presentAutoAlert('saveTemplate', err);
      });
    }


    /***** Fields modal controls *****/
    $scope.openNewFieldModal = function () {
      var options = {};
      if ($scope.activityEdit != null) {
        options.ignoreTypes = ['multiline', 'signature', 'label'];
      }
      $scope.newFieldFromParent(options, function (field) {
        if (field != null) {
          docketService.saveField(field, function (newField) {
            $scope.availableFields.push(newField);
            $scope.getFields();
          }, function (err) {
            $scope.alertService.presentAutoAlert('saveField', err);
          });
        }
      });
    }

    /***** Checklists modal controls *****/
    $scope.openNewChecklistModal = function () {
      $("#editChecklistModal").fadeIn(100);
      $scope.checklistEdit = { fields: [], name: '', type: 'docket' };
    }

    $scope.closeEditChecklistModal = function () {
      $("#editChecklistModal").fadeOut(100);
    }

    $scope.saveChecklistEdit = function (template) {
      template.loading = true;
      docketService.saveChecklistTemplate(template, function (templateUpdated) {
        $scope.getChecklists();
        var location = 1;
        if ($scope.templateEdit.checklistContainers.length > 0 && $scope.templateEdit.checklistContainers[$scope.templateEdit.checklistContainers.length - 1].location != null) {
          location = $scope.templateEdit.checklistContainers[$scope.templateEdit.checklistContainers.length - 1].location + 1
        }
        var newChecklistContainer = { location: location, rule: 'notRequired', checklistTemplate: templateUpdated };
        $scope.availableChecklists.push(newChecklistContainer);
        $scope.checklistEdit = null;
        $scope.closeEditChecklistModal();
      }, function (err) {
        template.loading = false;
        $scope.alertService.presentAutoAlert('saveChecklistTemplate', err);
      });
    }

    $scope.removeChecklistField = function (field, template) {
      var index = template.fields.indexOf(field);
      if (index != -1) {
        template.fields.splice(index, 1);
      }
    }

    $scope.addChecklistField = function (template) {
      if (template.fields == null) {
        template.field = [];
      }
      var newField = {};
      newField.id = uuid.v4();
      template.fields.push(newField);
    }

    /**************************************/
    /**** Docket Template Attachments *****/
    /**************************************/

    $scope.leftPaneAnimationInProcess = false;
    $scope.RightPaneAnimationInProcess = false;

    $scope.uploadNewTermsAttachment = function ($file) {
      $scope.templateEdit.loading = true;
      Upload.upload({
        method: 'PUT',
        url: DOCKETBOOK_API_URL + '/' + $scope.urlVersion + '/organisations/' + $scope.currentOrg.id + "/groups/" + $scope.currentOrgGroup.id + "/templates/" + $scope.templateEdit.id + "/attachment",
        data: { file: $file, type: 'termsConditions' },
        withCredentials: true
      }).then(function (resp) {
        $scope.templateEdit.loading = false;
        $scope.getTemplate();
      }, function (resp) {
        $scope.templateEdit.loading = false;
        $scope.alertService.presentAutoAlert('saveTemplate', err);
      }, function (evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      });
    }

    $scope.removeTemplateAttachment = function (attachment) {
      $scope.templateEdit.loading = true;
      docketService.deleteTemplateAttachment($scope.templateEdit.id, attachment.id, function () {
        $scope.templateEdit.loading = false;
        $scope.getTemplate();
      }, function () {
        $scope.templateEdit.loading = false;
        $scope.alertService.presentAutoAlert('saveTemplate', err);
      });
    }

    $scope.minimiseLeftPane = function () {
      if (!$scope.leftPaneAnimationInProcess) {
        $scope.leftPaneAnimationInProcess = true;
        $("#leftControlPane .blocksList").fadeOut(100, function () { });
        $("#leftControlPane").animate({
          width: "50px",
          left: "0"
        }, 200, function () {
          $("#leftControlPane .paneHeader").addClass('minimised');
          $("#leftControlPane .blocksList").hide();
          $scope.leftPaneAnimationInProcess = false;
        });
      }
    }

    $scope.maximiseLeftPane = function () {
      if (!$scope.leftPaneAnimationInProcess) {
        $scope.leftPaneAnimationInProcess = true;
        $("#leftControlPane").animate({
          width: "250px"
        }, 200, function () {
          $("#leftControlPane .paneHeader").removeClass('minimised');
          $("#leftControlPane .blocksList").fadeIn(200);
          $scope.leftPaneAnimationInProcess = false;
        });
      }
    }

    $scope.minimiseRightPane = function () {
      if (!$scope.rightPaneAnimationInProcess) {
        $scope.rightPaneAnimationInProcess = true;
        $("#rightControlPane .paneListButtons").fadeOut(100);
        $("#rightControlPane .fieldsList").fadeOut(100, function () { })
        $("#rightControlPane").animate({
          width: "50px",
          right: "0px"
        }, 200, function () {
          $("#rightControlPane .paneHeader").addClass('minimised');
          $("#rightControlPane").addClass('minimised');
          $("#rightControlPane .fieldsList").hide();
          $scope.rightPaneAnimationInProcess = false;
        });
      }
    }

    $scope.maximiseRightPane = function () {
      if (!$scope.rightPaneAnimationInProcess) {
        $scope.rightPaneAnimationInProcess = true;
        $("#rightControlPane").animate({
          width: "250px"
        }, 200, function () {
          $("#rightControlPane").removeClass('minimised');
          $("#rightControlPane .paneHeader").removeClass('minimised');
          $("#rightControlPane .fieldsList").fadeIn(200);
          $("#rightControlPane .paneListButtons").fadeIn(100);
          $scope.rightPaneAnimationInProcess = false;
        });
      }
    }

    $scope.windowWidth = $(window).width();

    $scope.checkLeftPaneHover = function () {
      if ($("#leftControlPane") && $scope.windowWidth < 1600) {
        if ($scope.windowWidth < 1600 && $("#leftControlPane:hover").length > 0) {
          $scope.maximiseLeftPane();
          $scope.checkLeftPaneHoverOut();
        } else {
          $scope.minimiseLeftPane();
        }
      }
    }

    $scope.checkRightPaneHover = function () {
      if ($("#rightControlPane") && $scope.windowWidth < 1600) {
        if ($scope.windowWidth < 1600 && $("#rightControlPane:hover").length > 0) {
          $scope.maximiseRightPane();
          $scope.checkRightPaneHoverOut();
        } else {
          $scope.minimiseRightPane();
        }
      }
    }

    $scope.checkLeftPaneHoverOut = function () {
      if ($scope.windowWidth < 1600) {
        if ($("#leftControlPane:hover").length > 0) {
          $timeout(function () {
            $scope.checkLeftPaneHoverOut();
          }, 300);
        } else {
          $scope.minimiseLeftPane();
        }
      }
    }

    $scope.checkRightPaneHoverOut = function () {
      if ($("#rightControlPane:hover").length > 0) {
        $timeout(function () {
          $scope.checkRightPaneHoverOut();
        }, 300);
      } else {
        $scope.minimiseRightPane();
      }
    }
  });



// WEBPACK FOOTER //
// ./src/controllers/docketDesigner/designer.js